module.exports = __webpack_public_path__ + "de903c3c74441985d036a60d827f2345.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_40.mp3
// module id = 447
// module chunks = 0